import { render } from "./ReadabilitySeoRate.vue?vue&type=template&id=1f7a697a"
import script from "./ReadabilitySeoRate.vue?vue&type=script&lang=js"
export * from "./ReadabilitySeoRate.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__